export default "__VITE_ASSET__DFSYcAVp__"